export function InvitationsCreateModule() {
    return <div>Hello</div>;
}